import { ParamsService } from './services/params.service';
import { DataService } from './services/data.service';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { routing } from './app.routes';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';

import { AppComponent } from './app.component';
import { HeaderComponent } from 'src/app/component/header/header.component';
import { FooterComponent } from './component/footer/footer.component';
import { MapComponent } from './component/map/map.component';
import { MenuLinkComponent } from './component/menu-link/menu-link.component';
import { BlocContentComponent } from './component/bloc-content/bloc-content.component';
import { MenuComponent } from './component/menu/menu.component';
import { PageAddressComponent } from './pages/page-address/page-address.component';
import { PageInfoComponent } from './pages/page-info/page-info.component';
import { PageCompanyComponent } from './pages/page-company/page-company.component';
import { PageRouteComponent } from './pages/page-route/page-route.component';
import { PageServiceComponent } from './pages/page-service/page-service.component';
import { ToogleComponent } from './utils/toogle/toogle.component';
import { InputTextComponent } from './utils/input-text/input-text.component';
import { InputSelectComponent } from './utils/input-select/input-select.component';
import { CompanyListItemComponent } from './utils/company-list-item/company-list-item.component';
import { AddressComponent } from './utils/address/address.component';
import { DeferloadDirective } from './directives/deferload.directive';
import { ModalComponent } from './component/modal/modal.component';
import { MytestDirective } from './directives/mytest.directive';
import { DirectionStepsComponent } from './component/direction-steps/direction-steps.component';
import { DeviceDetectorModule } from 'ngx-device-detector';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MapComponent,
    MenuLinkComponent,
    BlocContentComponent,
    MenuComponent,
    PageAddressComponent,
    PageInfoComponent,
    PageCompanyComponent,
    PageRouteComponent,
    PageServiceComponent,
    ToogleComponent,
    InputTextComponent,
    InputSelectComponent,
    CompanyListItemComponent,
    AddressComponent,
    ModalComponent,
    MytestDirective,
    DirectionStepsComponent,
    DeferloadDirective,
  ],
  imports: [
		BrowserModule,
		routing,
		ReactiveFormsModule,
		FormsModule,
		LayoutModule,
		HttpClientModule,
		DeviceDetectorModule.forRoot(),
  ],
  providers: [
		DataService,
		ParamsService,
	],
  bootstrap: [AppComponent]
})
export class AppModule { }
